import React from 'react'
import Service from './role.service'
import { Link, withRouter } from 'react-router-dom'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import { connect } from 'react-redux'
import Filters from './filters.component'
import Pagination from '../../../components/pagination/pagination.component'
import './roles.styles.scss'
import iconNew from '../../../assets/icons/new-light.svg'
import { FormatDate } from '../../../utils/UIHelper'
import iconDelete from '../../../assets/icons/delete-red.svg'
import iconEdit from '../../../assets/icons/edit-dark.svg'
import DeleteRole from './components/delete/delete.component'

class Roles extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    componentDidMount() {
        this.service.loadRoles()
    }

    onPageChange = page => {
        this.setState({
            ...this.state,
            currentPage: page
        }, () => this.service.loadRoles())
    }

    onFilterChange = e => {
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                value: "",
                [e.target.name]: e.target.value
            }
        })
    }

    onFilterSubmit = e => {
        e.preventDefault()
        this.service.loadRoles()
    }

    toggleShowDelete = role => this.setState({
        ...this.state,
        showDelete: !this.state.showDelete,
        roleToDelete: role
    })

    onDelete = () => this.setState({
        ...this.state,
        showDelete: false,
        roles: this.state.roles.filter(role => role.id !== this.state.roleToDelete.id)
    })

    render() {
        return (
            <>
                {this.state.loading && <Dialog><Loading /></Dialog>}
                {this.state.showDelete && <Dialog><DeleteRole role={this.state.roleToDelete} onDelete={this.onDelete} onCancel={() => this.toggleShowDelete(null)} /></Dialog>}
                <div className="roles">
                    <div className="header">
                        <h4>Roles</h4>
                        <div className="buttons">
                        <Link className="btn" to="/security/roles/create"><img alt="" src={iconNew} />New Role</Link>
                            <Filters filter={this.state.filter} onSubmit={this.onFilterSubmit} onChange={this.onFilterChange} />
                        </div>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Permissions</th>
                                <th>Created</th>
                                <th>Updated</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.roles.map((role, key) => <tr key={key}>
                                    <td>{role.name}</td>
                                    <td>{role.rolePermissions.length}</td>
                                    <td>{FormatDate(role.created * 1000)}</td>
                                    <td>{FormatDate(role.updated * 1000)}</td>
                                    <td>
                                        <div className="actions">
                                            <img alt="" src={iconEdit} onClick={() => this.props.history.push('/security/roles/' + role.id)} />
                                            <img alt="" src={iconDelete} onClick={() => this.toggleShowDelete(role)} />
                                        </div>
                                    </td>
                                </tr>)
                            }
                        </tbody>
                    </table>
                    {
                        this.state.total > 0 && <Pagination totalItemsCount={this.state.total} currentIndex={this.state.currentPage} itemsPerPage={this.state.pageSize} onChange={this.onPageChange} />
                    }
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(Roles))